import axios from "axios";

export const getUserTickets = async () => {
  try {
    const response = await axios.get("/api/Ticket/GetUserTickets");
    return response.data;
  } catch (error) {
    console.error("Tickets fetch failed:", error);
    throw error;
  }
};

export const getTicketDetails = async (ticketId) => {
  try {
    const response = await axios.get(
      `/api/Ticket/GetTicketDetails?ticketId=${ticketId}`
    );
    return response.data;
  } catch (error) {
    console.error("Ticket details fetch failed:", error);
    throw error;
  }
};

export const closeTicket = async (ticketId) => {
  try {
    const response = await axios.put(
      `/api/Ticket/CloseTicket?ticketId=${ticketId}`
    );
    return response.data;
  } catch (error) {
    console.error("Close ticket failed:", error);
    throw error;
  }
};

export const sendMessage = async (ticketId, message) => {
  try {
    const response = await axios.post(
      `/api/Ticket/SendMessage?ticketId=${ticketId}&message=${message}`
    );
    return response.data;
  } catch (error) {
    console.error("Send message failed:", error);
    throw error;
  }
};

export const getTicketMessages = async (ticketId) => {
  try {
    const response = await axios.post(
      `/api/Ticket/GetTicketMessages?ticketId=${ticketId}`
    );
    return response.data;
  } catch (error) {
    console.error("Get messages failed:", error);
    throw error;
  }
};

export const createTicket = async (subject, description) => {
  try {
    const response = await axios.post("/api/Ticket/CreateTicket", {
      subject: subject,
      description: description,
    });
    return response.data;
  } catch (error) {
    console.error("Create ticket failed:", error);
    throw error;
  }
};
